import menu from '@/routes/privateRoutes';

export function getDefaultPath() {
    const getParent = ((route) => {
        const parent = [];
        if (!route) return parent;
        menu.forEach((option) => {
            if (option.subMenus) {
                option.subMenus.forEach((child) => {
                    const regex = new RegExp(`\\b${child.accessor}\\b`);
                    if (regex.test(route)) {
                        parent.push(child.accessor.toUpperCase());
                        parent.push(option.accessor.toUpperCase());
                    }
                });
            } else if (route.match(option.accessor)) {
                parent.push(option.accessor.toUpperCase());
            }
        });
        return parent;
    });

    const route = window.location.pathname;
    if (route) {
        return getParent(route);
    }
    return [];
}
